import Hirers from '@/api/hirers'

export default {
  namespaced: true,
  state: {
    hirers: [],
    hirerLoading: false
  },
  mutations: {
    setHirer (state, hirers) {
      state.hirers = hirers
    },
    addHirer (state, hirer) {
      state.hirers.unshift(hirer)
    },
    updateJob (state, hirer) {
      const index = state.hirers.findIndex(j => j.id === hirer.id)
      if (index === -1) { return state.hirers.push(hirer) }
      state.hirers[index] = hirer
    },
    removeHirer (state, hirerId) {
      state.hirers = state.hirers.filter(j => j.id !== hirerId)
    },
    setHirerLoading (state, hirerLoading) {
      state.hirerLoading = hirerLoading
    }
  },
  actions: {
    async getHirers ({commit}) {
      commit('setHirerLoading', true)
      const hirers = await Hirers.list()
      commit('setHirer', hirers)
      commit('setHirerLoading', false)
    },
    async getJobBoardOwnerHirers ({commit}, id) {
      commit('setHirerLoading', true)
      const hirers = await Hirers.getJobBoardOwnerHirers(id)
      commit('setHirer', hirers)
      commit('setHirerLoading', false)
    },
    async newHirer ({commit}, hirer) {
      commit('addHirer', hirer)
    },
    async getHirer ({commit}, id) {
      const hirer = await Hirers.get(id)
      commit('hirerForm/setHirer', hirer, {root: true})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin-hirers.js